export function callBoralTel(boralTel: string) {
  if (!boralTel) {
    return
  }
  window.open(`tel:${boralTel}`, `_self`)
}
